import React, { useRef, useEffect, useState } from "react";
import { MdCreditScore } from "react-icons/md";

//import components
import DropdownSelect from "../../../assets/reusableComponents/dropDownSelect";
import { ToastContainer, toast, Zoom, Bounce } from "react-toastify";
import customToasts from "../../../assets/reusableComponents/myToasts";

//import resize function
import { vw, vh } from "../../../assets/reusableComponents/resizeFunction";

//redux imports
import { useSelector, useDispatch } from "react-redux";

//tour utilities
import {
  advanceTour,
  isInTourMode,
  getCurrentTourStep,
} from "../../../../utils/tourUtils";
import {
  tenant,
  updateTenant,
  fetchTenants,
  relocateTenant,
  deleteTenant,
  getAllProperties,
  promptPayment,
  createSTK,
  checkSTKStatus,
} from "../../../../redux/slices/sliceActions";

const TenantModificationModal = ({
  setShowPay,
  fieldToShow,
  tenantData,
  setTenantData,
  selectedPropertyId,
  selectedHouseId,
  setSelectedHouseId,
  handleShowModal,
  newTenantInvoice,
}) => {
  useEffect(() => {
    if (!newTenantInvoice) return;
    customToasts.info(
      "Invoices for this tenant has already been created, please proceed to STK prompt payment"
    );
    console.log("new tenant invoice", newTenantInvoice);
  }, [newTenantInvoice]);

  // data fetched from the store
  const { houses, tenants } = useSelector((state) => state.landlordslice);
  const houseNumbers = houses.filter((house) => house.house_no !== "");

  const modalRef = useRef();
  const [isClosing, setIsClosing] = useState(false);
  const [isSmallScreen, setIsSmallScreen] = useState(false);

  //navitation
  const [currentStep, setCurrentStep] = useState(1);
  const [isStep1Completed, setIsStep1Completed] = useState(false);
  const [isStep2Completed, setIsStep2Completed] = useState(false);
  const [translationValue, setTranslationValue] = useState(0);
  const [isNextButtonHovered, setIsNextButtonHovered] = useState(false);

  useEffect(() => {
    if (currentStep === 2) {
      setTranslationValue("-110%");
    }
  }, [currentStep]);

  //variables to store input data
  //create new tenant
  const tenantTypeChoices = ["new", "existing"];
  const [selectedTenantType, setSelectedTenantType] = useState(
    tenantTypeChoices[0]
  );

  // Phone validation states
  const [phoneError, setPhoneError] = useState("");
  const [tenantPhoneError, setTenantPhoneError] = useState("");

  // Phone number validation function for Kenyan numbers
  const validateKenyanPhone = (phone) => {
    const phoneRegex = /^(07|01)\d{8}$/;
    return phoneRegex.test(phone);
  };

  const [isExistingTenant, setIsExistingTenant] = useState(false);
  useEffect(() => {
    if (selectedTenantType === "existing") {
      setIsExistingTenant(true);
    } else {
      setIsExistingTenant(false);
    }
  }, [selectedTenantType]);
  const [isTenantTypeSelected, setIsTenantTypeSelected] = useState(false);

  const [fullNames, setFullNames] = useState("");
  const [email, setEmail] = useState("");
  const [nationalID, setNationalID] = useState("");
  const [phoneNumber, setPhoneNumber] = useState("");
  const [paidDeposit, setPaidDeposit] = useState("");
  const [unpaidDeposit, setUnpaidDeposit] = useState("");
  const [garbage, setGarbage] = useState("");
  const [rent, setRent] = useState("");
  const [arrears, setArrears] = useState("");
  const [unpaidWaterBills, setUnpaidWaterBills] = useState("");
  const [unpaidGarbage, setUnpaidGarbage] = useState("");
  const [houseAssigned, setHouseAssigned] = useState("");
  const [entryDate, setEntryDate] = useState("");

  const [rentSTK, setRentSTK] = useState(
    newTenantInvoice ? newTenantInvoice.rent : ""
  );
  const [garbageSTK, setGarbageSTK] = useState(
    newTenantInvoice ? newTenantInvoice.rent : ""
  );
  const [depositSTK, setDepositSTK] = useState(
    newTenantInvoice ? newTenantInvoice.unpaid_deposit : ""
  );

  //month variables
  const [selectedMonth, setSelectedMonth] = useState(
    "Select month which rent is for"
  );

  const date = new Date();
  const currentMonth = date.toLocaleString("default", { month: "long" });
  date.setMonth(date.getMonth() + 1);
  const nextMonth = date.toLocaleString("default", { month: "long" });
  const currentYear = date.getFullYear();

  const monthChoices = [
    `Current Month (${currentMonth} ${currentYear})`,
    `Next Month (${nextMonth} ${currentYear})`,
  ];

  // Tenant state for the form
  const [tenantInfo, setTenantInfo] = useState({
    firstName: tenantData.firstName,
    lastName: tenantData.lastName,
    email: tenantData.email,
    phoneNumber: tenantData.phoneNumber,
    emergencyContact: "",
    nationalId: tenantData.nationalID,
  });

  // useEffect(() => {
  //   if (tenantData) {
  //     setTenantInfo({
  //       firstName: tenantData.firstName,
  //       lastName: tenantData.lastName,
  //       email: tenantData.email,
  //       phoneNumber: tenantData.phoneNumber,
  //       emergencyContact: "",
  //       nationalId: tenantData.nationalID,
  //     });
  //   }
  //   console.log("tenant info reset", tenantData);
  // }, [tenantData]);

  // Check if the screen is small
  useEffect(() => {
    const handleResize = () => {
      setIsSmallScreen(window.innerWidth <= 768); // Small and medium screens
    };

    handleResize(); // Initial check
    window.addEventListener("resize", handleResize);
    return () => window.removeEventListener("resize", handleResize);
  }, []);

  // Handle closing the modal
  const closeModal = () => {
    setIsClosing(true);
    setTenantData({});
    // setTimeout(() => setShowPay(false), 300); // Slight delay for close animation
    setShowPay(false);
    setCurrentStep(1);
  };

  // Handle input changes
  const handleInputChange = (e) => {
    const { name, value } = e.target;

    // // Validate phone number for tenant info
    // if (name === "phoneNumber") {
    //   if (value && !validateKenyanPhone(value)) {
    //     setTenantPhoneError("Phone number must be in format 07XXXXXXXX or 01XXXXXXXX");
    //   } else {
    //     setTenantPhoneError("");
    //   }
    // }

    setTenantInfo((prevInfo) => ({
      ...prevInfo,
      [name]: value,
    }));
  };

  // House selection for edit tenant unspecified
  const handleHouseSelection = () => {
    console.log("Selected house ID: ", selectedHouseId);
    console.log("the houses", tenants);
    const selectedTenant = tenants.find(
      (tenant) => tenant.house === selectedHouseId
    );
    if (selectedTenant) {
      setTenantInfo({
        firstName: selectedTenant.user.name.split(" ")[0],
        lastName: selectedTenant.user.name.split(" ")[1],
        email: selectedTenant.user.email,
        phoneNumber: selectedTenant.user.phone,
        nationalId: selectedTenant.user.ID,
        entryDate: selectedTenant.createdAt,
        id: selectedTenant.user?._id,
        currentHouseNumber: selectedTenant.house_no,
      });
      setTenantData(tenantInfo);
    }
  };

  // Add state for the new house number
  // const [selectedHouseId, setSelectedHouseId] = useState('');
  const [selectedNewHouseNumber, setSelectedNewHouseNumber] = useState(""); // For new house number

  // This function will handle selecting the new house number for the tenant
  const handleNewHouseSelection = (event) => {
    setSelectedNewHouseNumber(event.target.value);
  };

  // This function will handle moving the tenant to the new house
  const handleMoveTenant = () => {
    console.log(`Moving tenant to house number: ${selectedNewHouseNumber}`);
    if (selectedHouseId && selectedNewHouseNumber) {
      dispatch(
        relocateTenant({
          userID: tenantInfo.id,
          new_house_id: selectedNewHouseNumber,
        })
      ).then((res) => {
        console.log("response", res);
        if (res.payload.status === "success") {
          console.log("Tenant moved successfully");
          setSelectedNewHouseNumber("");
          setSelectedHouseId("");
          dispatch(fetchTenants({ property_id: selectedPropertyId }));
          closeModal();
        }
      });
    }
  };

  //methods to send data
  const dispatch = useDispatch();

  const handleCreateTenant = (e) => {
    e.preventDefault();

    //ensure all required fields are filled
    if (!fullNames || !email || !nationalID || !phoneNumber || !entryDate) {
      toast.error("Please fill in all required fields before submitting.");
      return;
    }

    // Validate phone number before submission
    if (!validateKenyanPhone(phoneNumber)) {
      setPhoneError("Phone number must be in format 07XXXXXXXX or 01XXXXXXXX");
      toast.error("Please enter a valid Kenyan phone number");
      return;
    }

    const formatDate = (dateString) => {
      if (!dateString) return "";
      const date = new Date(dateString);
      return date.toISOString().split("T")[0];
    };

    let newTenant;

    const getMonthNumber = (monthName) => {
      const monthNames = [
        "January",
        "February",
        "March",
        "April",
        "May",
        "June",
        "July",
        "August",
        "September",
        "October",
        "November",
        "December",
      ];

      const monthNumber = monthNames.indexOf(monthName) + 1;
      return monthNumber > 0 ? monthNumber : null; // Return null if the month name is invalid
    };
    const selectedMonthName = selectedMonth.includes("Current")
      ? currentMonth
      : nextMonth;
    const monthOfPayment = getMonthNumber(selectedMonthName);

    if (selectedTenantType === "new") {
      newTenant = {
        name: fullNames,
        email,
        phone: `+254${phoneNumber.substring(1)}`, // Convert to international format
        ID: nationalID,
        entry_date: formatDate(entryDate),
        // paid_deposit: parseInt(paidDeposit, 10),
        // arrears,
        // water: parseInt(unpaidWaterBills, 10),
        // //set current month
        // month: new Date().getMonth() + 1,
        // year: new Date().getFullYear(),
        isExisting: isExistingTenant,
        // service_charge: 0,
        // garbage: 0,
        // unpaid_deposit: parseInt(unpaidDeposit, 10),
        // rent: parseInt(rent, 10),

        // reference: "",
        // method: "MPesa",
        // water: parseInt(unpaidWaterBills, 10),
      };
    } else {
      newTenant = {
        name: fullNames,
        email,
        phone: `+254${phoneNumber.substring(1)}`, // Convert to international format
        ID: nationalID,
        entry_date: formatDate(entryDate),
        // paid_deposit: parseInt(paidDeposit, 10),
        // service_charge: 0,
        garbage: parseInt(unpaidGarbage, 10),
        arrears: parseInt(arrears, 10),
        unpaid_deposit: parseInt(unpaidDeposit, 10),
        // rent: parseInt(rent, 10),
        month: new Date().getMonth() + 1,
        year: new Date().getFullYear(),
        // reference: "",
        // method: "MPesa",
        water: parseInt(unpaidWaterBills, 10),
        isExisting: isExistingTenant,
      };
    }
    customToasts
      .promise(
        dispatch(
          tenant({
            newTenant: newTenant,
            houseId: houseAssigned,
            isNewTenant: selectedTenantType === "new" ? true : false,
          })
        ).unwrap(),
        {
          pending: "Creating Tenant...",
          success: "Tenant created successfully",
          error: "Error Creating Tenant",
        }
      )
      .then((response) => {
        if (response?.status === "success") {
          dispatch(fetchTenants({ property_id: selectedPropertyId })).then(
            (res) => {
              const tenants = res.payload;
              // Find the tenant that matches the created tenant's details
              const createdTenantData = response.data;
              const lastTenant = tenants.find(
                (tenant) =>
                  tenant.user &&
                  tenant.user.name === createdTenantData.name &&
                  tenant.user.email === createdTenantData.email &&
                  tenant.user.phone === createdTenantData.phone &&
                  tenant.user.ID === createdTenantData.ID &&
                  tenant.house_no === createdTenantData.house_no &&
                  tenant.house === createdTenantData.house_id
              );
              if (lastTenant) {
                setTenantData({
                  id: lastTenant.user._id,
                  name: lastTenant.user.name,
                  entryDate: lastTenant.entry_date,
                  apartmentNumber: lastTenant.house_no,
                  email: lastTenant.user.email,
                  houseType: lastTenant.house_type,
                  firstName: lastTenant.user.name.split(" ")[0],
                  lastName: lastTenant.user.name.split(" ")[1],
                  phoneNumber: lastTenant.user.phone,
                  nationalId: lastTenant.user.ID,
                  houseId: lastTenant.house,
                });
              }
            }
          );
          dispatch(getAllProperties()).then((res) =>
            console.log("properties", res.payload)
          );

          // Advance tour if in tour mode and on Tenants step
          if (isInTourMode() && getCurrentTourStep() === 2) {
            advanceTour();
          }

          closeModal();
          if (selectedTenantType === "new") {
            // Reset the step to 1 to start with invoice creation
            setCurrentStep(1);
            setIsStep1Completed(false);
            setIsStep2Completed(false);
            setTranslationValue(0);
            handleShowModal("prompt payment");
          }
        }
      })
      .catch((error) => {
        console.error("Error creating tenant:", error);
        return; // Exit the function on error
      });
  };
  //payment state
  const [submissionState, setSubmissionState] = useState("idle"); // 'idle', 'loading', 'complete', 'failed'
  const [failureMessage, setFailureMessage] = useState(
    "Payment was not completed. Please try again or contact support."
  );

  const setNextStep = async () => {
    if (!newTenantInvoice && currentStep === 1) {
      handlePromptFirstPayment();
    }
    if (currentStep === 2 || newTenantInvoice) {
      //check if rentSTK, garbageSTK, and depositSTK are filled
      if (!rentSTK || !garbageSTK || !depositSTK) {
        toast.error("Please fill in all payment details before proceeding.");
        return;
      }
      // Check if tenantInfo.phoneNumber is filled and valid
      if (!tenantInfo.phoneNumber) {
        toast.error("Please enter the tenant's phone number.");
        return;
      }
      if (!validateKenyanPhone(tenantInfo.phoneNumber)) {
        toast.error(
          "Please enter a valid Kenyan phone number (07XXXXXXXX or 01XXXXXXXX)"
        );
        return;
      }
      setSubmissionState("loading");
      const getMonthNumber = (monthName) => {
        const monthNames = [
          "January",
          "February",
          "March",
          "April",
          "May",
          "June",
          "July",
          "August",
          "September",
          "October",
          "November",
          "December",
        ];

        const monthNumber = monthNames.indexOf(monthName) + 1;
        return monthNumber > 0 ? monthNumber : null; // Return null if the month name is invalid
      };
      const selectedMonthName = selectedMonth.includes("Current")
        ? currentMonth
        : nextMonth;
      const monthOfPayment = getMonthNumber(selectedMonthName);
      const paymentDetails = {
        rent: parseInt(rentSTK, 10),
        garbage: parseInt(garbageSTK, 10),
        unpaid_deposit: parseInt(depositSTK, 10),
        month: newTenantInvoice ? newTenantInvoice?.month : monthOfPayment,
        year: new Date().getFullYear(),
        house_id: tenantData?.houseId,
        phone: `+254${tenantInfo.phoneNumber.substring(1)}`, // Convert to international format
      };

      // customToasts
      //   .promise(dispatch(createSTK({ paymentDetails })), {
      //     pending: "Creating STK prompt...",
      //     success: "STK sent successfully",
      //     error: "Failed to create STK push",
      //   })
      //   .then((res) => {
      //     console.log("complete", res);
      //     closeModal();
      //   });
      //start
      const stkResponse = dispatch(createSTK({ paymentDetails })).then(
        (res) => {
          console.log("STK Response:", res?.payload);
          if (res?.payload?.status === "success") {
            const checkoutRequestId = res?.payload?.data?.checkoutRequestId;
            console.log(
              "Starting polling for checkout request:",
              checkoutRequestId
            );

            // Start polling for payment status
            const pollInterval = setInterval(async () => {
              try {
                const response = await dispatch(
                  checkSTKStatus({ checkoutRequestId })
                );
                console.log("Polling response:", response);

                const responseData = response?.payload?.data;
                const isCompleted = responseData?.isCompleted;
                const isFailed = responseData?.isFailed;
                const isExpired = responseData?.isExpired;
                const shouldStopPolling = responseData?.shouldStopPolling;
                const payment = responseData?.payment;
                const failureReason = responseData?.failureReason;

                // Stop polling if the API indicates we should stop
                if (shouldStopPolling === true) {
                  clearInterval(pollInterval);

                  if (isCompleted === true && payment) {
                    // Payment successful
                    console.log("Payment successful!", payment);
                    setSubmissionState("complete");

                    setIsStep1Completed(true);
                    setCurrentStep(2);
                    setIsStep2Completed(true);
                  } else if (isFailed === true || isExpired === true) {
                    // Payment failed, expired, or was cancelled
                    console.log(
                      "Payment failed:",
                      failureReason || "Payment was not completed"
                    );
                    setFailureMessage(
                      failureReason ||
                        "Payment was not completed. Please try again or contact support."
                    );
                    setSubmissionState("failed");
                  } else {
                    // Other failure scenarios
                    console.log("Payment failed or cancelled");
                    setFailureMessage(
                      "Payment was not completed. Please try again or contact support."
                    );
                    setSubmissionState("failed");
                  }
                }
                // If shouldStopPolling is false, continue polling (payment still pending)
              } catch (error) {
                console.error("Polling error:", error);
                clearInterval(pollInterval);
                setSubmissionState("failed");
              }
            }, 5000); // Poll every 5 seconds
            customToasts.promise(
              dispatch(
                fetchTenants({ property_id: selectedPropertyId })
              ).unwrap(),
              {
                pending: "Fetching Tenants...",
                success: "Tenants fetched successfully",
                error: "Failed to fetch tenants",
              }
            );
            // Set a timeout to stop polling after 5 minutes
            setTimeout(() => {
              clearInterval(pollInterval);
              if (submissionState === "loading") {
                console.log("Polling timeout - payment took too long");
                setSubmissionState("failed");
              }
            }, 300000); // 5 minutes timeout
          } else {
            console.error("No checkout request ID received from STK response");
            setSubmissionState("failed");
          }
        }
      );
    }
  };

  const handlePromptFirstPayment = async () => {
    if (!rent || !unpaidDeposit) {
      toast.error("Please fill in all payment details before proceeding.");
      return;
    }

    const getMonthNumber = (monthName) => {
      const monthNames = [
        "January",
        "February",
        "March",
        "April",
        "May",
        "June",
        "July",
        "August",
        "September",
        "October",
        "November",
        "December",
      ];

      const monthNumber = monthNames.indexOf(monthName) + 1;
      return monthNumber > 0 ? monthNumber : null; // Return null if the month name is invalid
    };
    const selectedMonthName = selectedMonth.includes("Current")
      ? currentMonth
      : nextMonth;
    const monthOfPayment = getMonthNumber(selectedMonthName);
    const paymentDetails = {
      rent: parseInt(rent, 10),
      garbage: parseInt(garbage, 10),
      unpaid_deposit: parseInt(unpaidDeposit, 10),
      month: monthOfPayment,
      year: new Date().getFullYear(),
    };

    customToasts
      .promise(
        dispatch(
          promptPayment({
            paymentDetails,
            houseId: tenantData?.houseId,
          })
        ),
        {
          pending: "Creating Invoice For Tenant...",
          success: "Invoice created successfully",
          error: "Failed to create Invoice",
        }
      )
      .then((res) => {
        console.log("response for prompting payment", res);

        setIsStep1Completed(true);
        setCurrentStep(2);
        setIsStep2Completed(true);
      });
  };

  //update tenant
  const handleUpdateTenant = (e) => {
    e.preventDefault();

    // Validate phone number before submission
    if (
      tenantInfo.phoneNumber &&
      !validateKenyanPhone(tenantInfo.phoneNumber)
    ) {
      toast.error(
        "Please enter a valid Kenyan phone number (07XXXXXXXX or 01XXXXXXXX)"
      );
      return;
    }

    const updateDetails = {
      name: tenantInfo.firstName + " " + tenantInfo.lastName,
      email: tenantInfo.email,
      phone: tenantInfo.phoneNumber
        ? `+254${tenantInfo.phoneNumber.substring(1)}`
        : tenantInfo.phoneNumber,
      ID: tenantInfo.nationalId,
      emergency_contact: tenantInfo.emergencyContact,
    };
    dispatch(
      updateTenant({ updateInfo: updateDetails, houseId: selectedHouseId })
    ).then((res) => {
      if (res?.payload?.status === "success") {
        console.log("Tenant updated successfully");
        closeModal();
      }
    });
    dispatch(fetchTenants({ property_id: selectedPropertyId }));
  };

  //delete tenant
  const handleDeleteTenant = (e) => {
    e.preventDefault();
    console.log("i am clicked");
    dispatch(deleteTenant({ userID: tenantInfo.id })).then((res) => {
      console.log("response", res);
      if (res?.payload?.status === "success") {
        console.log("Tenant updated successfully");
        setSelectedNewHouseNumber("");
        dispatch(fetchTenants({ property_id: selectedPropertyId }));
        closeModal();
      }
    });
  };

  // Modal content based on the fieldToShow
  const renderModalContent = () => {
    if (fieldToShow === "create new tenant") {
      if (!isTenantTypeSelected) {
        return (
          <>
            <div style={{ ...styles.mainTitle, color: "#192A3A" }}>
              Create Tenant
            </div>
            <div
              style={{
                ...styles.subTitle,
                color: "#666",
                marginBottom: vh(20),
              }}
            >
              Please select if this is a new or existing tenant
            </div>
            <div style={{ marginBottom: vh(40) }}>
              <DropdownSelect
                choices={tenantTypeChoices}
                defaultChoice={selectedTenantType}
                onSelect={setSelectedTenantType}
                backgroundColor={"#ffffff"}
                textColor={"#192a3a"}
                border={"1px solid #cccccc"}
              />
            </div>

            <button
              style={styles.button}
              onMouseEnter={() => setHover(true)}
              onMouseLeave={() => setHover(false)}
              onClick={() => {
                setIsTenantTypeSelected(true);
              }}
            >
              Confirm
            </button>
          </>
        );
      }
      return (
        <form>
          <label>Personal Information</label>
          <input
            style={styles.input}
            type="text"
            placeholder="Full Names"
            value={fullNames}
            onChange={(e) => setFullNames(e.target.value)}
          />
          <input
            style={styles.input}
            type="email"
            placeholder="Email"
            value={email}
            onChange={(e) => setEmail(e.target.value)}
          />
          <input
            style={styles.input}
            type="number"
            placeholder="National ID"
            value={nationalID}
            onChange={(e) => setNationalID(e.target.value)}
          />
          <input
            style={{
              ...styles.input,
              borderColor: phoneError ? "#dc3545" : "#ccc",
            }}
            type="text"
            placeholder="Phone Number eg 07XXXXXXXX or 01XXXXXXXX"
            value={phoneNumber}
            onChange={(e) => {
              const value = e.target.value;
              setPhoneNumber(value);
              // if (value && !validateKenyanPhone(value)) {
              //   setPhoneError("Phone number must be in format 07XXXXXXXX or 01XXXXXXXX");
              // } else {
              //   setPhoneError("");
              // }
            }}
          />
          {phoneError && (
            <div
              style={{
                color: "#dc3545",
                fontSize: "12px",
                marginTop: "-8px",
                marginBottom: "8px",
              }}
            >
              {phoneError}
            </div>
          )}
          <label style={{ marginTop: vh(10) }}>Entry Date and Details</label>
          <input
            type="date"
            style={styles.input}
            value={entryDate}
            onChange={(e) => setEntryDate(e.target.value)}
          />

          {/* {selectedTenantType !== "existing" && (
            <div style={styles.dropDownSelect}>
              <DropdownSelect
                choices={monthChoices}
                defaultChoice={selectedMonth}
                onSelect={setSelectedMonth}
                backgroundColor={"#ffffff"}
                textColor={"#192a3a"}
                border={"1px solid #cccccc"}
              />
            </div>
          )} */}

          {selectedTenantType === "existing" && (
            <>
              {/* <div style={styles.sideBySide}>
                <input
                  style={styles.input}
                  type="number"
                  placeholder="Paid Deposit"
                  value={paidDeposit}
                  onChange={(e) => setPaidDeposit(e.target.value)}
                />
                <input
                  style={styles.input}
                  type="number"
                  placeholder="Unpaid Deposit"
                  value={unpaidDeposit}
                  onChange={(e) => setUnpaidDeposit(e.target.value)}
                />
              </div> */}

              <div style={styles.sideBySide}>
                <input
                  style={styles.input}
                  type="number"
                  placeholder="Unpaid Deposit"
                  value={unpaidDeposit}
                  onChange={(e) => setUnpaidDeposit(e.target.value)}
                />
                <input
                  style={styles.input}
                  type="number"
                  placeholder="Arrears"
                  value={arrears}
                  onChange={(e) => setArrears(e.target.value)}
                />
              </div>
              <div style={styles.sideBySide}>
                <input
                  style={styles.input}
                  type="number"
                  placeholder="Unpaid Water Bills"
                  value={unpaidWaterBills}
                  onChange={(e) => setUnpaidWaterBills(e.target.value)}
                />
                <input
                  style={styles.input}
                  type="number"
                  placeholder="Unpaid Garbage Bills"
                  value={unpaidGarbage}
                  onChange={(e) => setUnpaidGarbage(e.target.value)}
                />
              </div>
            </>
          )}

          <select
            style={styles.input}
            name="houseNumber"
            onChange={(e) => setHouseAssigned(e.target.value)}
          >
            <option value="">Select House Number</option>
            {houseNumbers
              .filter((house) => house.status !== "occupied")
              .map((house) => (
                <option key={house} value={house?._id}>
                  {house?.house_no}
                </option>
              ))}
          </select>
          <div style={styles.sideBySide}>
            <button
              style={styles.button}
              onMouseEnter={() => setHover(true)}
              onMouseLeave={() => setHover(false)}
              type="submit"
              onClick={handleCreateTenant}
            >
              Create Tenant
            </button>
          </div>
        </form>
      );
    }

    if (fieldToShow === "modify tenant") {
      return (
        <div>
          {Object.keys(tenantData).length === 0 ? (
            <>
              <div style={{ ...styles.mainTitle, color: "#192A3A" }}>
                Edit Tenant
              </div>
              <div
                style={{
                  ...styles.subTitle,
                  color: "#666",
                  marginBottom: vh(20),
                }}
              >
                Please select house number of tenant to edit
              </div>
              <select
                style={styles.input}
                name="houseNumber"
                onChange={(e) => setSelectedHouseId(e.target.value)}
              >
                <option value="">Select House Number</option>
                {houseNumbers
                  .filter((house) => house.status !== "vacant")
                  .map((house, index) => (
                    <option key={house?._id} value={house?._id}>
                      {house?.house_no}
                    </option>
                  ))}
              </select>
              <button style={styles.button} onClick={handleHouseSelection}>
                Confirm
              </button>
            </>
          ) : (
            <form>
              <div style={{ ...styles.mainTitle, color: "#192A3A" }}>
                Edit Tenant
              </div>
              <div
                style={{
                  ...styles.subTitle,
                  color: "#666",
                  marginBottom: vh(20),
                }}
              >
                Please update the tenant's information below
              </div>
              <div style={styles.sideBySide}>
                <input
                  type="text"
                  name="firstName"
                  placeholder="First Name"
                  value={tenantInfo.firstName}
                  style={{ ...styles.input, marginBottom: vh(10) }}
                  onChange={handleInputChange}
                />
                <input
                  type="text"
                  name="lastName"
                  placeholder="Last Name"
                  value={tenantInfo.lastName}
                  style={{ ...styles.input, marginBottom: vh(10) }}
                  onChange={handleInputChange}
                />
              </div>
              <input
                type="email"
                name="email"
                placeholder="Email"
                style={styles.input}
                value={tenantInfo.email}
                onChange={handleInputChange}
              />
              <input
                type="text"
                name="phoneNumber"
                placeholder="Phone Number eg 07XXXXXXXX or 01XXXXXXXX"
                style={{
                  ...styles.input,
                  borderColor: tenantPhoneError ? "#dc3545" : "#ccc",
                }}
                value={tenantInfo.phoneNumber}
                onChange={handleInputChange}
              />
              {tenantPhoneError && (
                <div
                  style={{
                    color: "#dc3545",
                    fontSize: "12px",
                    marginTop: "-8px",
                    marginBottom: "8px",
                  }}
                >
                  {tenantPhoneError}
                </div>
              )}
              <input
                type="text"
                name="emergencyContact"
                placeholder="Emergency Contact"
                value={tenantInfo.emergencyContact}
                style={styles.input}
                onChange={handleInputChange}
              />
              <input
                type="number"
                name="nationalId"
                placeholder="National ID Number"
                value={tenantInfo.nationalId}
                style={styles.input}
                onChange={handleInputChange}
              />

              <button
                style={styles.button}
                onMouseEnter={() => setHover(true)}
                onMouseLeave={() => setHover(false)}
                type="submit"
                onClick={handleUpdateTenant}
              >
                Save Changes
              </button>
            </form>
          )}
        </div>
      );
    }

    if (fieldToShow === "prompt payment") {
      return (
        <>
          <div style={styles.progressBarContainer}>
            <div
              style={{ ...styles.stepCircle, ...styles.stepCircleCompleted }}
            ></div>

            <div
              style={{ ...styles.stepDivider, ...styles.stepDividerCompleted }}
            ></div>

            <div
              style={{
                ...styles.stepCircle,
                ...(isStep1Completed
                  ? styles.stepCircleCompleted
                  : styles.nextStepCircle),
              }}
            ></div>
          </div>

          <div style={styles.stepsSlider}>
            {!newTenantInvoice && (
              <div style={styles.individualStepContainer}>
                <div style={{ ...styles.mainTitle, color: "#192A3A" }}>
                  Amount to be paid (Optional)
                </div>
                <div
                  style={{
                    ...styles.subTitle,
                    color: "#666",
                    marginBottom: vh(20),
                  }}
                >
                  Please enter the ammounts to be paid
                </div>
                <label>Invoice Details</label>
                <input
                  style={styles.input}
                  type="number"
                  placeholder="Rent"
                  value={rent}
                  onChange={(e) => setRent(e.target.value)}
                />
                <div style={styles.dropDownSelect}>
                  <DropdownSelect
                    choices={monthChoices}
                    defaultChoice={selectedMonth}
                    onSelect={setSelectedMonth}
                    backgroundColor={"#ffffff"}
                    textColor={"#192a3a"}
                    border={"1px solid #cccccc"}
                  />
                </div>
                <div style={styles.sideBySide}>
                  {/* <input
              style={styles.input}
              type="number"
              placeholder="Paid Deposit"
              value={paidDeposit}
              onChange={(e) => setPaidDeposit(e.target.value)}
            /> */}
                  <input
                    style={styles.input}
                    type="number"
                    placeholder="Deposit"
                    value={unpaidDeposit}
                    onChange={(e) => setUnpaidDeposit(e.target.value)}
                  />
                </div>

                <div style={styles.sideBySide}>
                  <input
                    style={styles.input}
                    type="number"
                    placeholder="Garbage"
                    value={garbage}
                    onChange={(e) => setGarbage(e.target.value)}
                  />
                </div>
              </div>
            )}

            {submissionState === "loading" ? (
              <div className="loading-container" style={{ minWidth: "100%" }}>
                <div className="loader"></div>

                <div
                  style={{
                    textAlign: "center",
                    marginTop: "20px",
                    fontSize: "14px",
                    color: "#666",
                    minWidth: "100%",
                  }}
                >
                  Please complete the payment on your phone. Waiting for
                  confirmation...
                </div>
              </div>
            ) : submissionState === "complete" ? (
              <div className="complete-container">
                <div
                  className="complete-animation"
                  style={{
                    color: "#28a745",
                    fontSize: "18px",
                    fontWeight: "bold",
                    minWidth: "100%",
                  }}
                >
                  Payment Successful!
                </div>
                <div
                  style={{
                    textAlign: "center",
                    color: "#28a745",
                    marginTop: "10px",
                    fontSize: "14px",
                  }}
                >
                  Your payment has been processed successfully.
                </div>
              </div>
            ) : submissionState === "failed" ? (
              <div
                className="failed-container"
                style={{
                  textAlign: "center",
                  padding: "20px",
                  minWidth: "100%",
                }}
              >
                <div
                  style={{
                    color: "#dc3545",
                    fontSize: "18px",
                    fontWeight: "bold",
                    marginBottom: "10px",
                  }}
                >
                  Payment Failed
                </div>
                <div
                  style={{
                    color: "#dc3545",
                    fontSize: "14px",
                    marginBottom: "20px",
                  }}
                >
                  {failureMessage}
                </div>
                <div style={{ display: "flex" }}>
                  <button
                    type="button"
                    className="submit-btn"
                    onClick={() => setSubmissionState("idle")}
                    style={{ marginRight: "10px" }}
                  >
                    Try Again
                  </button>
                  <button
                    type="button"
                    className="close-btn"
                    onClick={closeModal}
                  >
                    Close
                  </button>
                </div>
              </div>
            ) : (
              <div style={styles.individualStepContainer}>
                <div style={{ ...styles.mainTitle, color: "#192A3A" }}>
                  STK for invoice payment (Optional)
                </div>
                <div
                  style={{
                    ...styles.subTitle,
                    color: "#666",
                    marginBottom: vh(20),
                  }}
                >
                  Please enter details to prompt payment
                </div>
                <label>Rent</label>
                <input
                  style={styles.input}
                  type="number"
                  placeholder="Rent"
                  value={rentSTK}
                  onChange={(e) => setRentSTK(e.target.value)}
                />
                <label>Garbage</label>
                <input
                  style={styles.input}
                  type="number"
                  placeholder="Garbage"
                  value={garbageSTK}
                  onChange={(e) => setGarbageSTK(e.target.value)}
                />
                <label>Deposit</label>
                <input
                  style={styles.input}
                  type="number"
                  placeholder="Deposit"
                  value={depositSTK}
                  onChange={(e) => setDepositSTK(e.target.value)}
                />
                <label>Contact Details</label>
                <input
                  type="text"
                  name="phoneNumber"
                  placeholder="Phone Number eg 07XXXXXXXX or 01XXXXXXXX"
                  style={styles.input}
                  value={tenantInfo.phoneNumber}
                  onChange={handleInputChange}
                />
              </div>
            )}
          </div>
          {submissionState === "idle" && (
            <div style={{ ...styles.sideBySide, marginTop: vh(50) }}>
              <button
                style={styles.cancel}
                onMouseEnter={() => setHover(true)}
                onMouseLeave={() => setHover(false)}
                onClick={closeModal}
              >
                Cancel
              </button>

              <button
                style={{
                  ...styles.nextButton,
                  ...(isNextButtonHovered ? styles.nextButtonHover : {}),
                }}
                onMouseEnter={() => setIsNextButtonHovered(true)}
                onMouseLeave={() => setIsNextButtonHovered(false)}
                onClick={() => {
                  setNextStep();
                }}
              >
                Next
              </button>
            </div>
          )}
        </>
      );
    }

    if (fieldToShow === "delete tenant") {
      if (Object.keys(tenantData).length === 0) {
        // tenantData is an empty object
        return (
          <>
            <div style={{ ...styles.mainTitle, color: "#192A3A" }}>
              Delete Tenant
            </div>
            <div
              style={{
                ...styles.subTitle,
                color: "#666",
                marginBottom: vh(20),
              }}
            >
              Please select house of tenant to delete
            </div>
            <select
              style={styles.input}
              name="houseNumber"
              onChange={(e) => setSelectedHouseId(e.target.value)}
            >
              <option value="">Select House Number</option>
              {houseNumbers
                .filter((house) => house.status !== "vacant")
                .map((house, index) => (
                  <option key={house?._id} value={house?._id}>
                    {house?.house_no}
                  </option>
                ))}
            </select>
            <button style={styles.button} onClick={handleHouseSelection}>
              Confirm
            </button>
          </>
        );
      } else {
        // tenantData contains data
        return (
          <div>
            <div style={{ ...styles.mainTitle, color: "#192A3A" }}>
              Delete Tenant
            </div>
            <div
              style={{
                ...styles.subTitle,
                color: "#666",
                marginBottom: vh(20),
              }}
            >
              Please confirm the details of the tenant you wish to delete
            </div>

            <div
              style={{
                padding: vh(20),
                borderRadius: vw(12),
                marginTop: vh(15),
                border: "1px solid rgba(179, 147, 89, 0.2)",
              }}
            >
              <div
                style={{
                  display: "grid",
                  gap: vw(12),
                }}
              >
                {[
                  ["Name", `${tenantInfo.firstName} ${tenantInfo.lastName}`],
                  ["Current House", tenantInfo.currentHouseNumber],
                  ["Tenant ID", tenantInfo.tenantId],
                  ["Email", tenantInfo.email],
                  ["Phone", tenantInfo.phoneNumber],
                ].map(([label, value]) => (
                  <p
                    key={label}
                    style={{
                      margin: "0",
                      padding: vh(8),
                      borderBottom: "1px solid rgba(179, 147, 89, 0.1)",
                      display: "flex",
                      justifyContent: "space-between",
                      alignItems: "center",
                    }}
                  >
                    <strong style={{ color: "#192A3A" }}>{label}:</strong>
                    <span style={{ color: "#666" }}>{value}</span>
                  </p>
                ))}
              </div>
            </div>
            <div style={{ ...styles.sideBySide, marginTop: vh(20) }}>
              <button
                style={styles.cancel}
                onMouseEnter={() => setHover(true)}
                onMouseLeave={() => setHover(false)}
                onClick={closeModal}
              >
                Cancel
              </button>
              <button
                style={styles.confirm}
                onMouseEnter={() => setHover(true)}
                onMouseLeave={() => setHover(false)}
                onClick={handleDeleteTenant}
              >
                Confirm Deletion
              </button>
            </div>
          </div>
        );
      }
    }

    if (fieldToShow === "move tenant") {
      return (
        <div>
          {Object.keys(tenantData).length === 0 ? (
            <>
              <div style={{ ...styles.mainTitle, color: "#192A3A" }}>
                Move Tenant
              </div>
              <div
                style={{
                  ...styles.subTitle,
                  color: "#666",
                  marginBottom: vh(20),
                }}
              >
                Please select house of tenant to move
              </div>
              <select
                style={styles.input}
                name="houseNumber"
                onChange={(e) => setSelectedHouseId(e.target.value)}
              >
                <option value="">Select House Number</option>
                {houseNumbers
                  .filter((house) => house.status !== "vacant")
                  .map((house, index) => (
                    <option key={house?._id} value={house?._id}>
                      {house?.house_no}
                    </option>
                  ))}
              </select>
              <button style={styles.button} onClick={handleHouseSelection}>
                Confirm
              </button>
            </>
          ) : (
            <>
              <div>
                <div style={{ ...styles.mainTitle, color: "#192A3A" }}>
                  Move Tenant
                </div>
                <div
                  style={{
                    ...styles.subTitle,
                    color: "#666",
                    marginBottom: vh(20),
                  }}
                >
                  Please confirm tenant details and select new house
                </div>

                <div
                  style={{
                    padding: vh(20),
                    borderRadius: vw(12),
                    marginTop: vh(15),
                    border: "1px solid rgba(179, 147, 89, 0.2)",
                  }}
                >
                  <div
                    style={{
                      display: "grid",
                      gap: vw(12),
                    }}
                  >
                    {[
                      [
                        "Name",
                        `${tenantInfo.firstName} ${tenantInfo.lastName}`,
                      ],
                      ["Current House", tenantInfo.currentHouseNumber],
                      ["Tenant ID", tenantInfo.tenantId],
                      ["Email", tenantInfo.email],
                      ["Phone", tenantInfo.phoneNumber],
                    ].map(([label, value]) => (
                      <p
                        key={label}
                        style={{
                          margin: "0",
                          padding: vh(8),
                          borderBottom: "1px solid rgba(179, 147, 89, 0.1)",
                          display: "flex",
                          justifyContent: "space-between",
                          alignItems: "center",
                        }}
                      >
                        <strong style={{ color: "#192A3A" }}>{label}:</strong>
                        <span style={{ color: "#666" }}>{value}</span>
                      </p>
                    ))}
                  </div>
                </div>

                <h4 style={{ marginTop: vh(20), color: "#192A3A" }}>
                  Select New House Number
                </h4>
                <select
                  style={styles.input}
                  name="newHouseNumber"
                  onChange={handleNewHouseSelection}
                >
                  <option value="">Select New House Number</option>
                  {houseNumbers
                    .filter((house) => house.status === "vacant")
                    .map((house) => (
                      <option key={house} value={house?._id}>
                        {house?.house_no}
                      </option>
                    ))}
                </select>

                {selectedNewHouseNumber && (
                  <button
                    style={styles.button}
                    type="button"
                    onClick={handleMoveTenant}
                    onMouseEnter={() => setHover(true)}
                    onMouseLeave={() => setHover(false)}
                  >
                    Move Tenant
                  </button>
                )}
              </div>
            </>
          )}
        </div>
      );
    }
  };

  // if (!isSmallScreen) return null; // Return nothing if it's not a small/medium screen

  //styling
  //hover functionality for button
  const [hover, setHover] = useState(false);
  const styles = {
    overlay: {
      position: "fixed",
      top: 0,
      left: 0,
      width: "100%",
      height: "100%",
      backgroundColor: "rgba(0, 0, 0, 0.7)", // Dark translucent overlay
      display: "flex",
      alignItems: "center",
      justifyContent: "center",
      zIndex: 9999,
    },
    modalContent: {
      backgroundColor: "white",
      padding:
        fieldToShow === "prompt payment"
          ? `${vh(20)} ${vw(20)} ${vh(20)} ${vw(20)}`
          : `${vh(40)} ${vw(20)} ${vh(20)} ${vw(20)}`,

      borderRadius: "8px",
      width: "90%", // Adapt to smaller screens
      maxWidth: "500px",
      boxShadow: "0 5px 15px rgba(0, 0, 0, 0.3)",
      position: "relative",
      zIndex: 10000, // Ensure it's above the overlay
      animation: "fadeIn 0.3s ease",
      overflowX: "hidden",
    },
    closeBtn: {
      position: "absolute",
      top: "10px",
      right: "15px",
      fontSize: vh(24),
      background: "none",
      border: "none",
      cursor: "pointer",
    },
    progressBarContainer: {
      display: "flex",
      justifyContent: "start",
      alignItems: "center",
      margin: `${vh(20)} 0px ${vh(20)}  0px`,
      gap: vw(5),
    },
    stepCircle: {
      width: vh(11),
      height: vh(11),
      borderRadius: "50%",
      backgroundColor: "#ddd",
      transition: "background-color 0.3s ease",
    },
    stepCircleCompleted: {
      backgroundColor: "#192A3A",
    },
    nextStepCircle: {
      border: "1.5px solid #192A3A",
      width: vh(11),
      height: vh(11),
      backgroundColor: "transparent",
      transition: "background-color 0.3s ease",
    },

    stepDivider: {
      width: vw(500),
      height: vh(2),
      borderRadius: vw(5),
      backgroundColor: "#ccc",
      transition: "background-color 0.3s ease",
    },
    stepDividerCompleted: {
      backgroundColor: "#192A3A",
      transition: "background-color 0.3s ease",
    },
    mainTitle: {
      fontSize: vh(24),
      fontWeight: "700",
      marginBottom: vh(5),
    },
    subTitle: {
      fontSize: vh(16),
      fontWeight: "300",
      color: "#666",
    },
    input: {
      width: "100%",
      padding: vh(10),
      marginBottom: vh(10),
      borderRadius: vw(5),
      border: "1px solid #ccc",
    },
    dropDownSelect: {},
    button: {
      width: "100%",
      padding: vh(10),
      borderRadius: vw(5),
      border: "none",
      backgroundColor: hover ? "#B39359" : "#192A3A",
      color: "white",
      cursor: "pointer",
      transition: "background-color 0.3s ease",
    },

    sideBySide: {
      display: "flex",
      flexDirection: "row",
      gap: vw(10),
      alignItems: "center",
    },
    confirm: {
      padding: vh(10),
      borderRadius: vw(5),
      border: "none",
      backgroundColor: "#192A3A",
      color: "white",
      cursor: "pointer",
      width: "50%",
      transition: "background-color 0.3s ease",
    },
    nextButton: {
      width: "50%",
      padding: vh(10),
      backgroundColor: "#192A3A",
      color: "white",
      borderRadius: vw(5),
      border: "none",
      cursor: "pointer",
      transition: "background-color 0.3s ease",
    },
    nextButtonHover: {
      backgroundColor: "#B39359",
    },
    cancel: {
      padding: vh(10),
      borderRadius: vw(5),
      border: "none",
      backgroundColor: "#B39359",
      color: "white",
      cursor: "pointer",
      width: "50%",
      transition: "background-color 0.3s ease",
    },
    stepsSlider: {
      display: "flex",
      flexDirection: "row",
      gap: "10%",
      position: "relative",
      width: "100%",
      // height: currentStep === 2 ? vh(150) : vh(280),
      transform: `translateX(${translationValue})`,
      transition: "all 1s ease",
    },
    individualStepContainer: {
      minWidth: "100%",
      // position: "absolute",
    },
  };

  return (
    <div style={styles.overlay}>
      <div style={styles.modalContent} ref={modalRef}>
        {fieldToShow === "prompt payment" ? (
          <></>
        ) : (
          <button style={styles.closeBtn} onClick={closeModal}>
            &times;
          </button>
        )}

        {renderModalContent()}
      </div>

      <ToastContainer
        position="bottom-left"
        autoClose={5000}
        hideProgressBar={false}
        newestOnTop={false}
        closeOnClick={false}
        rtl={false}
        pauseOnFocusLoss
        draggable
        pauseOnHover
        theme="light"
        transition={Bounce}
      />
    </div>
  );
};

export default TenantModificationModal;
